module.exports = __webpack_public_path__ + "static/SevenRooms-7334eaf922d88641d67f4ea6875fc0da.jpg";